import { ItemTranslationsPatch } from "../../typings/translations";
import "./resource";

class ItemService {
    public static $inject: string[] = ["$log", "$q", "itemResource", "itemTranslationsResource"];

    constructor(
        private $log: ng.ILogService,
        private $q: ng.IQService,
        private resource,
        private itemTranslationsResource
    ) {}

    public get(id: number) {
        return this.resource().get({ id: id }).$promise;
    }

    public update(id: number, fields: Object) {
        return this.resource().update({ id: id }, fields).$promise;
    }

    public publish(id: number) {
        return this.resource().publish({ id: id }).$promise;
    }

    public reset(id: number) {
        return this.resource().reset({ id: id }).$promise;
    }

    public getMedias(id: number, organizationId: number = null) {
        const headers = organizationId
            ? { "x-organization": organizationId }
            : null;
        return this.resource(headers).getMedias({ id: id }).$promise;
    }

    public createMedia(id: number, body: Object) {
        return this.resource().createMedia({ id: id }, body).$promise;
    }

    public translate(id: number, body: ItemTranslationsPatch) {
        return this.itemTranslationsResource()
            .translate({ id }, JSON.stringify(body))
            .$promise.catch(error => {
                this.$log.error(`Error on Item translations ${id}`, error);
                return this.$q.reject(error);
            });
    }
}

angular
    .module("thor.core.item.service", [
        "thor.core.item.resource"
    ])
    .service("itemService", ItemService);
